import React from 'react';
import { unescapeHTML } from 'underscore.string';
import { Translation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import DropdownItem from '../v2/dropdowns/DropdownItem';
import Badge from '../v2/Badge';

const roleStyles = {
  Shipper: 'brand',
  Carrier: 'blue',
  Driver: 'blue',
  Unauthorized: 'red',
  Vendor: 'purple',
  Consignee: 'pink',
  Broker: 'orange',
};

export const renderItem = (item, isHiglighted) => {
  const unauthorized =
    (item.type === 'Carrier' || item.type === 'Driver') && !item.authorized;

  const color = unauthorized ? roleStyles.Unauthorized : roleStyles[item._type];
  const text = unauthorized ? 'Unauthorized' : item._type;

  const name =
    item.type === 'Consignee'
      ? unescapeHTML(item.company_name)
      : unescapeHTML(item.name);
  const carrier = unescapeHTML(item.carrier);

  return (
    <DropdownItem
      isHiglighted={isHiglighted}
      key={item.value}
      className="list-group-item"
    >
      <Translation>
        {(t, { i18n }) => (
          <div className="flex -mx-4">
            <div className="px-4 w-36">
              <Badge rounded color={color} className="label">
                {t(sluggify(text))}
              </Badge>
            </div>
            <div className="w-1/4 px-4">
              <span className="font-bold searchName">{name}</span>
              {item.carrier && (
                <div>
                  <span className="italic text-grey">{carrier}</span>
                </div>
              )}
            </div>
            {item.is_broker && (
              <div className="w-36 px-4">
                <Badge rounded color={roleStyles.Broker} className="label">
                  {t('BROKER')}
                </Badge>
              </div>
            )}
            {item._type !== 'Driver' && (
              <div className="w-1/2 px-4">
                <span className="text-xs text-grey" id="user-email">
                  {item.email}
                </span>
              </div>
            )}
          </div>
        )}
      </Translation>
    </DropdownItem>
  );
};
